import { useBookAccessLog } from '@!/Hooks'
import { LatelyAccessList } from '@!/Store/Common/components/LatelyAccessList'

export const ScrollableLatelyAccessList = ({ genreTabName }) => {
  const [titles, isLoading, handleResetLog, showLatelyAccessList] = useBookAccessLog()
  const gtmClick = genreTabName ? `${genreTabName}_lately` : 'home_lately'

  return showLatelyAccessList && <LatelyAccessList titles={titles} isLoading={isLoading} handleResetLog={handleResetLog} gtmClick={gtmClick} />
}
